"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarginAlert = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _NotificationItem = require("../NotificationItem");
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
var _Button = require("../../form/Button/Button");
require("./MarginAlert.css");
var _useMarginAlertActions = require("./useMarginAlertActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @typedef {Object} MarginNotificationType
 * @property {number} id
 * @property {'MarginCall'|'MarginPositionLiquidation'|'MarginOrderLiquidation'} type
 * @property {Object} data
 */

/**
 * @param {Object} props
 * @param {MarginNotificationType} props.item
 * @returns
 */

var MarginAlert = exports.MarginAlert = function MarginAlert(_ref) {
  var item = _ref.item;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var _useMarginAlertAction = (0, _useMarginAlertActions.useMarginAlertActions)(item),
    dismiss = _useMarginAlertAction.dismiss,
    viewActivity = _useMarginAlertAction.viewActivity;
  return /*#__PURE__*/_react["default"].createElement(_NotificationItem.NotificationItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
      name: "danger",
      customClass: "margin-alert-icon"
    }),
    className: "margin-notification",
    actions: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      variant: "primary",
      size: "md",
      onClick: viewActivity
    }, t('View Activity')), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      variant: "danger",
      size: "md",
      onClick: dismiss
    }, t('Dismiss')))
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h5", null, t("notification.".concat(item.type, ".title"), {
    ns: 'margin'
  })), /*#__PURE__*/_react["default"].createElement("p", null, t("notification.".concat(item.type, ".message"), _objectSpread({
    ns: 'margin'
  }, item.data)), " - ".concat(item.dateTime))));
};
MarginAlert.isApplicable = function (item) {
  return item.type.toLowerCase().startsWith('margin');
};